import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        title: '',
        showReturn: false,
        transitionName: '',
        showLoading: false,
        showToolBar: false
    },
    mutations: {
        title (state, title) {
            state.title = title
        },
        showReturn (state, value) {
            state.showReturn = value
        },
        setToolBarVisiable (state, value) {
            state.showToolBar = value
        },
        toggleLoading (state, value) {
            state.showLoading = value
        },
        updateDirection (state, value) {
            state.transitionName = value
        }
    },
    actions: {

    }
})
